module.exports = __webpack_public_path__ + "static/media/aboutUsMobBanner.b5c143bd.webp";